import * as tslib_1 from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Menu, Badge } from '@h3/antd-vue';
import * as WorkflowCenterNS from '../typings/workflow-center';
//二开S
const WorkflowCenterModule = namespace('WorkflowCenter/WorkflowCenter');
//二开E
// 引入流程中心store
import WorkflowCenterStore from '../store/workflow-center';
let WorkflowCenterMenu = class WorkflowCenterMenu extends Vue {
    constructor() {
        super(...arguments);
        // 二开E
        this.selectedKeys = [];
        this.specStyle = false;
    }
    ondragWidthChange(v) {
        if (v > 230) {
            this.specStyle = true;
        }
        else {
            this.specStyle = false;
        }
    }
    get unFinishedListCount() {
        return this.$store && this.$store.state.WorkflowCenterStore.unFinishedListCount;
    }
    get unReadListCount() {
        return this.$store && this.$store.state.WorkflowCenterStore.unReadListCount;
    }
    get admin() {
        return this.$store && this.$store.state.System.System.admin; // 引入系统store的字段 
    }
    get rootAdmin() {
        return this.$store && this.$store.state.System.System.isRootAdmin;
    }
    onAdminChange(val) {
        // console.log('admin change: ', val);
        this.setSelectedKeys();
    }
    routeChange() {
        this.setSelectedKeys();
    }
    created() {
        // 动态注册模块
        this.$store && this.$store.registerModule('WorkflowCenterStore', WorkflowCenterStore);
    }
    beforeMount() {
        this.setSelectedKeys();
        this.handleGetWorkCount();
    }
    // 根据当前路由判断当前选中
    setSelectedKeys() {
        let { name } = this.$route;
        if (!name)
            return;
        if (!this.admin && ['queryInstance', 'queryParticipantWorkItem'].includes(name)) {
            name = 'myUnfinishedWorkItem';
        }
        name = name.substring(0, 1).toUpperCase() + name.substring(1);
        let skey = 0;
        switch (name) {
            case 'MyUnfinishedWorkItem':
                skey = WorkflowCenterNS.SelectKeysMapping.MyUnfinishedWorkItem;
                break;
            case 'MyUnReadWorkItem':
                skey = WorkflowCenterNS.SelectKeysMapping.MyUnReadWorkItem;
                break;
            case 'MyFinishedWorkItem':
                skey = WorkflowCenterNS.SelectKeysMapping.MyFinishedWorkItem;
                break;
            case 'MyReadWorkItem':
                skey = WorkflowCenterNS.SelectKeysMapping.MyReadWorkItem;
                break;
            case 'MyWorkflow':
                skey = WorkflowCenterNS.SelectKeysMapping.MyWorkflow;
                break;
            case 'QueryInstance':
                skey = WorkflowCenterNS.SelectKeysMapping.QueryInstance;
                break;
            case 'QueryParticipantWorkItem':
                skey = WorkflowCenterNS.SelectKeysMapping.QueryParticipantWorkItem;
                break;
            case 'MyComments':
                skey = WorkflowCenterNS.SelectKeysMapping.MyComments;
                break;
            case 'DelegationWorkflow':
                skey = WorkflowCenterNS.SelectKeysMapping.DelegationWorkflow;
                break;
            default:
                skey = -1;
                break;
        }
        const _k = skey.toString();
        this.selectedKeys = [_k];
    }
    //二开钉钉历史数据查询跳转
    goDingding() {
        var app = {
            "id": "ff8080817a721822017a7aba20c95f8a",
            "remarks": null,
            "createdTime": "2021-07-06 15:30:56",
            "modifiedTime": "2021-07-06 16:52:13",
            "deleted": false,
            "createdBy": "ff8080817a371fbb017a38063d9a0ac6",
            "modifiedBy": null,
            "name": "流程中心",
            "name_i18n": "{\"en\":\"数据导入\"}",
            "code": "datainput",
            "sortKey": 7,
            "type": "BizModel",
            "icon": "h-icon-all-catalogue-o",
            "parentId": "ff808081798871870179a6a531554448",
            "appCode": "BasicData",
            "pcUrl": null,
            "mobileUrl": null,
            "openMode": null,
            "children": null,
            "pcAble": true,
            "mobileAble": true,
            "published": null
        };
        // :to="'/application/' + app.code"
        //  var  _url = `/application/${app.appCode}`;
        //  var  _url = `/application/${app.appCode}/application-list/${app.code}?queryCode=`;
        var _url = '/application/BasicData/application-list/datainput?parentId=ff808081798871870179a6a531554448&code=datainput&openMode&pcUrl&queryCode=&isdingdingslider=isdingdingslider';
        this.$router.push(_url);
        this.setAsideTitle(app);
    }
    // 二开
    // 获取任务数
    handleGetWorkCount() {
        this.$store.dispatch('WorkflowCenterStore/getWorkCount');
    }
    destroyed() {
        this.$store.unregisterModule('WorkflowCenterStore');
    }
};
tslib_1.__decorate([
    WorkflowCenterModule.Mutation('setAsideTitle')
], WorkflowCenterMenu.prototype, "setAsideTitle", void 0);
tslib_1.__decorate([
    Prop(Number)
], WorkflowCenterMenu.prototype, "dragWidth", void 0);
tslib_1.__decorate([
    Watch('dragWidth')
], WorkflowCenterMenu.prototype, "ondragWidthChange", null);
tslib_1.__decorate([
    Watch('admin')
], WorkflowCenterMenu.prototype, "onAdminChange", null);
tslib_1.__decorate([
    Watch('$route')
], WorkflowCenterMenu.prototype, "routeChange", null);
WorkflowCenterMenu = tslib_1.__decorate([
    Component({
        name: 'WorkflowCenterMenu',
        components: {
            AMenu: Menu,
            AMenuItem: Menu.Item,
            ASubMenu: Menu.SubMenu,
            ABadge: Badge
        }
    })
], WorkflowCenterMenu);
export default WorkflowCenterMenu;
